import { ListItem } from '../components/shared/entity-selector/entity-selector';

export function labelsDisplayCalc(labelsWidth: number, labelPadding: number, removeIconWidth: number,
                                  labelGap: number, avgCharacterWidth: number, selectedList: ListItem[]) {

    let currentLineWidth = 0;
    const displayLabels: ListItem[] = [];

    for (const item of selectedList) {
        const calculateWidth = (label: string) => label.length * avgCharacterWidth + labelPadding + labelGap + removeIconWidth;

        const labelWidth = calculateWidth(item.name);

        if (currentLineWidth + labelWidth > labelsWidth) {
            const remainingCount = () => selectedList.length - displayLabels.length;
            const plusLabel = `+${remainingCount()}`;
            const plusLabelWidth = calculateWidth(plusLabel);

            if (currentLineWidth + plusLabelWidth > labelsWidth) {
                displayLabels.pop();
            }
            // it should be calculated again since display labels length may be changed
            displayLabels.push({ name: `+${remainingCount()}`, key: item.key, data: item.data });
            break;
        }

        displayLabels.push(item);
        currentLineWidth += labelWidth;
    }

    return displayLabels;
}